import lodash from 'lodash'
import React, { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'

import {
  Col,
  FormRow,
} from '../../../../../../1stlog-ui/src/components/Bootstrap'
import { ListGroupItem } from '../../../../../../1stlog-ui/src/components/ListGroup'
import Removable from '../../../../../../1stlog-ui/src/components/Removable'
import AdrRulesDontApply from './AdrRulesDontApply'
import Amount from './Amount'
import ClassCode from './ClassCode'
import Count from './Count'
import Description from './Description'
import EnvironmentalHazard from './EnvironmentalHazard'
import ExplosiveMass from './ExplosiveMass'
import HazmatLabels from './HazmatLabels'
import HazmatPoints from './HazmatPoints'
import HazmatValidation from './HazmatValidation'
import LimitedQuantity from './LimitedQuantity'
import MaterialDescription from './MaterialDescription'
import Packaging from './Packaging'
import PackagingGroup from './PackagingGroup'
import TransportCategory from './TransportCategory'
import TunnelLimitation from './TunnelLimitation'
import UnNumber from './UnNumber'

const Wrapper = styled.div``

const DynamicCols = styled.div`
  display: flex;
  margin: -10px;

  & > * {
    margin: 10px;
  }
`

const Hazmat = (props) => {
  const { onRemove, index, name } = props

  const remove = () => onRemove(index)
  return (
    <ListGroupItem noMargin>
      <Removable onRemove={remove} withPadding>
        <Wrapper>
          <FormRow>
            <Col md={2}>
              <Count />
            </Col>
            <Col md={1}>
              <UnNumber name={name} />
            </Col>
            <Col md={3}>
              <Description />
            </Col>
            <Col md={2} xs={6}>
              <ClassCode />
            </Col>

            <Col md={4} xs={6} className="d-flex">
              <PackagingGroup />
              <TransportCategory />
              <TunnelLimitation />
            </Col>
          </FormRow>
          <FormRow>
            <Col md={2}>
              <Amount />
            </Col>
            <Col md={2}>
              <Packaging />
            </Col>
            <Col md={2} xs={6}>
              <ExplosiveMass />
            </Col>
            <Col md={2} xs={6}>
              <MaterialDescription />
            </Col>
            <Col md={4} xs={6}>
              <DynamicCols>
                <EnvironmentalHazard />
                <LimitedQuantity />
              </DynamicCols>
            </Col>
          </FormRow>
          <FormRow>
            <Col>
              <DynamicCols>
                <HazmatLabels />
                <HazmatPoints />
                <AdrRulesDontApply />
              </DynamicCols>
            </Col>
          </FormRow>
          <HazmatValidation />
        </Wrapper>
      </Removable>
    </ListGroupItem>
  )
}

export default Hazmat
